// extracted by mini-css-extract-plugin
export default {"btn":"cookieConsentir_btn__bVKet","p":"cookieConsentir_p__0Nkqy","Link":"cookieConsentir_Link__WXBmC"};